import { useState } from "react";
import axios from "axios";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [token, setToken] = useState("");
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axios.get(`${API}/volunteers`, { headers: { "X-Admin-Token": token } });
      setRows(res.data);
    } catch (e) {
      setError("Unauthorized or failed to load. Check the admin token.");
      setRows(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-5" data-testid="admin-page">
      <div className="max-w-5xl mx-auto">
        <h1 className="font-display text-3xl font-extrabold text-slate-900">Campaign Volunteers</h1>
        <p className="text-slate-500 mt-1">Enter the admin token to view submissions.</p>

        <div className="mt-6 flex flex-wrap items-end gap-3">
          <div className="flex-1 min-w-[220px]">
            <Label htmlFor="token" className="text-slate-700">Admin Token</Label>
            <Input
              id="token"
              type="password"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              placeholder="Enter token"
              className="mt-2 h-11 rounded-xl"
              data-testid="admin-token-input"
            />
          </div>
          <button
            onClick={load}
            disabled={loading || !token}
            className="rounded-full bg-slate-900 text-white font-semibold px-6 py-3 hover:bg-teal-700 transition-colors disabled:opacity-60"
            data-testid="admin-load-button"
          >
            {loading ? "Loading..." : "Load"}
          </button>
        </div>

        {error && <p className="mt-4 text-red-600" data-testid="admin-error">{error}</p>}

        {rows && (
          <div className="mt-8 overflow-x-auto rounded-2xl border border-slate-200 bg-white">
            <table className="w-full text-sm" data-testid="admin-table">
              <thead className="bg-slate-100 text-slate-600 text-left">
                <tr>
                  <th className="px-4 py-3 font-semibold">Name</th>
                  <th className="px-4 py-3 font-semibold">Email</th>
                  <th className="px-4 py-3 font-semibold">Phone</th>
                  <th className="px-4 py-3 font-semibold">Interests</th>
                  <th className="px-4 py-3 font-semibold">Message</th>
                  <th className="px-4 py-3 font-semibold">Date</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 && (
                  <tr><td colSpan={6} className="px-4 py-6 text-center text-slate-400">No submissions yet.</td></tr>
                )}
                {rows.map((r) => (
                  <tr key={r.id} className="border-t border-slate-100 align-top">
                    <td className="px-4 py-3 font-medium text-slate-900">{r.name}</td>
                    <td className="px-4 py-3 text-slate-600">{r.email}</td>
                    <td className="px-4 py-3 text-slate-600">{r.phone || "—"}</td>
                    <td className="px-4 py-3 text-slate-600">{(r.interests || []).join(", ") || "—"}</td>
                    <td className="px-4 py-3 text-slate-600 max-w-xs">{r.message || "—"}</td>
                    <td className="px-4 py-3 text-slate-500 whitespace-nowrap">{new Date(r.created_at).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
